import { ITagLeafAnyTableEvent } from '../../../../utils/apollo/graphqlSchema';
import { usePanelStateContext } from '../context';
import { isNil } from 'lodash';
import Loading from '../panel/Loading';
import {
  DetailsDescription,
  EntityTitle,
  NodeDetails,
  NodeDetailsHeader,
  NodeDetailsMain,
} from '../EntitySelectionPanelUI';
import { assertCondition } from '../../../../utils/types';

interface IProps {
  node: ITagLeafAnyTableEvent;
}

const AnyTableEventDetails = ({ node }: IProps) => {
  const { getEntityFromCache, entityLoading, selectNodeHandler } =
    usePanelStateContext();

  const selectedEntity = getEntityFromCache(node);

  if (entityLoading) {
    return <Loading />;
  } else if (!isNil(selectedEntity)) {
    assertCondition(selectedEntity.__typename === 'AnyTableEvent');
    return (
      <NodeDetails>
        <NodeDetailsHeader onClick={() => selectNodeHandler(node)}>
          <EntityTitle>{selectedEntity.name}</EntityTitle>
        </NodeDetailsHeader>
        <NodeDetailsMain>
          <DetailsDescription>
            Matches any event in this table
          </DetailsDescription>
        </NodeDetailsMain>
      </NodeDetails>
    );
  }

  return null;
};
export default AnyTableEventDetails;
